export { default as authService } from './authentication'
export { default as fileService } from './files'
export { default as leadService } from './leads'
export { default as adminService } from './admin'
export { default as campaignService} from './campaigns'
export { default as billingService} from './billing'
export {default as shopifyService} from './shopify'
export {default as draftsService} from './drafts'



// WEBPACK FOOTER //
// app/services/index.js